<template>
  <charger-request-form
    :form-name="formName"
    beam-title="Aanvraag publieke laadpaal"
    document-title="Go-Ral Aanvraag publieke paal"
    favicon-file-name="evtools-favicon.ico"
  >
    <template #logo>
      <logo-go-ral />
    </template>
    <template #dialogLogo>
      <logo-go-ral />
    </template>
  </charger-request-form>
</template>

<script>
import LogoGoRal from '../components/logos/LogoGoRal'
import ChargerRequestForm from '../components/ChargerRequestForm'

export default {
  components: {
    LogoGoRal,
    ChargerRequestForm,
  },
  props: {
    formName: {
      type: String,
      default: 'formConfigOpCharge',
    },
  },
}
</script>

<style lang="scss">
@import "~vuetify/src/styles/settings/_variables";

.op-charge {
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
  }
}
</style>
